import React from "react";
import FieldError from "../FieldError";
import DownArrow from "../../assets/images/DownArrow.svg"; // import your SVG

interface Option {
  value: string | number;
  label: string;
}

interface FloatingSelectFieldProps {
  name: string;
  label: string;
  register: any;
  registerOptions?: any;
  options: Option[];
  error?: any;
  required?: boolean;
  value?: string | number;
  style?: React.CSSProperties;
  className?: string;
}

export default function FloatingSelectField({
  name,
  label,
  register,
  registerOptions = {},
  options,
  error,
  required = false,
  value = "",
  style = {},
  className = "",
}: FloatingSelectFieldProps) {
  const hasValue = Boolean(value);
  const defaultOptions = required ? { required: "This field is required" } : {};
  const { onChange, ...rest } = register(name, {
    ...defaultOptions,
    ...registerOptions,
  });

  return (
    <>
      <div
        className={`floating-field field-wrapper mb-16 ${
          hasValue ? "has-value" : ""
        } ${className} ${error ? "error-field" : ""}`}
        style={{ position: "relative" }}
      >
        <select
          id={name}
          className="common-field"
          style={{
            height: "100%",
            ...style,
            paddingRight: "2rem",
            appearance: "none",
            WebkitAppearance: "none",
            MozAppearance: "none",
          }}
          value={value} // Use value instead of defaultValue
          {...rest}
          onChange={onChange}
          aria-describedby={`${name}-error`}
        >
          <option value="" disabled hidden></option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>

        <label htmlFor={name} className="field-label" role="presentation">
          {label}{" "}
          {required && (
            <span className="req-text" aria-label="required">
              *
            </span>
          )}
        </label>
        <img
          src={DownArrow}
          alt="dropdown arrow"
          style={{
            position: "absolute",
            right: "0.5rem",
            top: "50%",
            transform: "translateY(-50%)",
            pointerEvents: "none",
            width: "24px",
            height: "24px",
          }}
        />
      </div>
      <FieldError error={error} info={null} id={`${name}-error`} />
    </>
  );
}
